<template>
  <div name="hres7fe-detail">
    <div  class="box">
      <div class="box-body">
        <div class="detail detail-responsive">
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRES7FEC2']['10'] }}</label>
              <div class="col-md-4">
                <div class="form-control readonly-field-color">{{ setYearOutput(searchIndex.year) }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRES7FEC2']['20'] }}</label>
              <div class="col-md-4">
                <div class="form-control readonly-field-color">{{ indexSelected.codcours }} - {{ indexSelected.desc_codcours }}</div>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRES7FEC2']['30'] }}</label>
              <div class="col-md-4">
                <div class="form-control readonly-field-color">{{ indexSelected.numclseq }}</div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="box-tab">
      <div id="accordion"> 
        <div class="detail-block"> 

        <detail-tab1 :labels="labels"
                     :labelsButton="labelsButton"
                     :codeval="codeval"
                     :detailTab1="detail.tab1"
                     :postHres7feTab1Save="postHres7feTab1Save" 
                     :indexSelected="indexSelected"
                     :searchIndex="searchIndex"
                     :receivedHres7feDetail="receivedHres7feDetail"/>


        <detail-tab2 :labels="labels"
                     :labelsButton="labelsButton"
                     :detailTab2="detail.tab2"
                     :searchIndex="searchIndex"
                     :indexSelected="indexSelected"
                     :postHres7feTab2Save="postHres7feTab2Save" />
        </div> 
          
        <div class="box-footer">
          <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>   
        </div>

      </div>
    </div>


  </div>
</template>

<script>
import detailTab1 from 'components/hres7fe/detailTab1'
import detailTab2 from 'components/hres7fe/detailTab2'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hres7fe-detail',
  props: [ 'labels',
    'labelsButton',
    'nowLang',
    'toggle',
    'codeval',
    'descCodeval',
    'indexSelected',
    'searchIndex',
    'detail',
    'postHres7feTab1Save',
    'postHres7feTab2Save',
    'receivedHres7feDetail'
  ],
  methods: {
    setYearOutput (year) {
      return assetsUtils.getYearOutput(year)
    }
  },
  components: {
    detailTab1,
    detailTab2
  }
}
</script>



// WEBPACK FOOTER //
// detail.vue?6dfbe384